import { modalLayer } from '@utils'
import { ConfirmPreOrderModal } from '@pages/menu/modal'
import { multiPersonOrderingMobx, preOrderingMobx } from '@mobxStore'

class PreOrderingController {
  // 验证多人购物车已有餐品，如有餐品需要用户弹窗确认是否加入
  static checkHasCartItemsInCart () {
    if (preOrderingMobx.hasPreOrder) {
      if (Object.keys(multiPersonOrderingMobx.multiPersonData?.cartItem || []).length) {
        modalLayer(ConfirmPreOrderModal, { cartItems: preOrderingMobx.viewItems }, 'pre-order-modal')
          .then(() => {
            preOrderingMobx.addToCart()
          }).catch(() => {
            preOrderingMobx.clearCart()
          })
      } else {
        preOrderingMobx.addToCart()
      }
    }
  }
}

export default PreOrderingController
